import React, { useState } from "react";
import PropTypes from "prop-types";
import { validateInput } from "../../utilities/Validator";
import "../../css/common.css";

const SelectField = ({
  label,
  labelStyle,
  inputClass,
  labelClass,
  disabled,
  value,
  style,
  name,
  options,
  required,
  handleChange: change,
  validators,
  getError,
  valueKey,
  labelKey,
  disabledKey,
  onClick,
  Error,
  id,
  onInput,
  maxLength
}) => {
  const [error, setError] = useState(false);
  const handleChange = (val, labelName) => {
    if (validateInput(validators, val))
      setError(validateInput(validators, val));
    else if (!validateInput(validators, val) && value !== "") {
      setError(false);
    } else {
      setError(false);
    }
    change(val, labelName);
    getError &&
      getError(
        validateInput(validators, val) ? validateInput(validators, val) : false
      );
  };
  return (
    <>
      <div className={labelClass}>
        <label className="select-label" style={labelStyle ? labelStyle : {}}>
          {label}
          {required ? <b className={"text-danger"}> *</b> : ""}
        </label>
      </div>
      <div className={inputClass ? inputClass : "col-md-4"}>
        <div className="library-select">
          <select
            value={value}
            style={style ? style : {}}
            className="form-select"
            name={name}
            id={id}
           // defaultValue={value}
            onClick={onClick}
            onInput={onInput}
            disabled={disabled}
            maxLength={maxLength}
            onChange={(e) => {
              handleChange(e.target.value, e.target.selectedOptions[0].label)
            }}
          >
            {options.map((option, ind) => (
              <option
                value={option[valueKey]}
                key={ind}
                // disabled={option.value === ""}
                disabled={option[disabledKey]}
              >
                {option[labelKey]}
              </option>
            ))}
          </select>
        </div>
        {/* {required ? (
          <small className="text-danger">{<span>{required}</span>}</small>
        ) : (
          ""
        )} */}
          {(error || Error && Error[name]) && <span className="text-danger errormsg">{error.message|| Error[name]}</span>}
      </div>
    </>
  );
};
SelectField.prototype = {
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  validators: PropTypes.array,
  type: PropTypes.string,
  onchange: PropTypes.func.isRequired,
  labelClass: PropTypes.string,
  inputClass: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  disabledKey: PropTypes.bool,
};

SelectField.defaultProps = {
  value: "",
  label: "",
  placeholder: "",
  type: "select",
  labelClass: "col-md-4",
  inputClass: "col-md-6",
  valueKey: "value",
  labelKey: "label",
  disabledKey:"disabled",
};
export default SelectField;
